import React, { useEffect, useState } from 'react'

import { Button, Input, SelectInput, Divider } from 'src/components'

import { ancpReportOptions } from 'src/constants/ancpReport'
import { yupResolver } from '@hookform/resolvers/yup'
import { fileDownload } from 'src/assets/png'
import { API } from 'src/services/config'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { useStyles } from './styles'
import * as yup from 'yup'
import { PageTitle } from 'src/components/PageTitle'
import { useAuth } from 'src/contexts/auth'

const schema = yup.object().shape({
  type: yup.string().required('Campo obrigatório não preenchido').typeError('Campo obrigatório não preenchido'),
  propriedade: yup.string().required('Campo obrigatório não preenchido'),
  dataInicial: yup
    .date()
    .required('Campo obrigatório não preenchido')
    .when('dataFinal', (dataFinal, schema) => {
      const date = dataFinal?.toString() || ''
      if (date.includes('GMT')) {
        return schema.max(dataFinal, 'Data Inicial deve ser menor que a Data Final')
      }
      return schema.required('Campo obrigatório não preenchido')
    })
    .typeError('Campo obrigatório não preenchido'),
  dataFinal: yup.date().required('Campo obrigatório não preenchido').typeError('Campo obrigatório não preenchido')
})

export const ANCP: React.FC = () => {
  const style = useStyles()
  const { userFarm } = useAuth()
  const URL_API = 'https://api.congado.com.br'

  const [propertyList, setPropertyList] = useState([{}])
  const {
    watch,
    setValue,
    clearErrors,
    handleSubmit,
    formState: { errors }
  } = useForm<any>({ resolver: yupResolver(schema) })

  async function getProperty(idFazenda) {
    try {
      const response = await API.get('/entity/Fazenda')
      const farmToShow = response.data.filter((item: any) => item.idFazenda === idFazenda)
      setPropertyList(farmToShow)
    } catch (err: any) {
      toast.error('Não foi possivel carregar as propriedades, tente novamente.')
      setPropertyList([{}])
    }
  }

  const onSubmit = handleSubmit((data) => {
    const defaultData = {
      ...data,
      dataInicial: new Date(data.dataInicial || '').toISOString().split('T').shift(),
      dataFinal: new Date(data.dataFinal || '').toISOString().split('T').shift()
    }
    // eslint-disable-next-line max-len
    window.open(
      `${URL_API}${'/export_'}${data.type}${'_ancp.txt?idFazenda='}${data.propriedade}${'&tipo='}${data.type}${'&dataInicio='}${defaultData.dataInicial}${'&dataFinal='}${defaultData.dataFinal}`
    )
  })

  useEffect(() => {
    getProperty(userFarm)
  }, [])

  return (
    <>
      <PageTitle>ANCP</PageTitle>
      <Divider className={style.reportsDivider} />
      <div className={style.ancpForm}>
        <SelectInput
          label='Tipo'
          selectBy='id'
          showBy={['value']}
          options={ancpReportOptions}
          placeholder='Selecionar Tipo'
          value={watch('type') || ''}
          error={errors?.type?.message}
          onChange={(item: any) => {
            setValue('type', item.id)
            clearErrors('type')
          }}
        />
        <SelectInput
          label='Propriedade'
          selectBy='idFazenda'
          showBy={['descricao']}
          options={propertyList}
          value={watch('propriedade') || ''}
          error={errors?.propriedade?.message}
          placeholder='Selecionar Propriedade'
          onChange={(item: any) => {
            setValue('propriedade', item.idFazenda)
            clearErrors('propriedade')
          }}
        />
        <Input
          type='date'
          max='2999-12-31'
          label='Data Inicial'
          value={watch('dataInicial') || ''}
          error={errors?.dataInicial?.message}
          onChange={(item: any) => {
            setValue('dataInicial', item)
            clearErrors('dataInicial')
          }}
        />
        <Input
          type='date'
          max='2999-12-31'
          label='Data Final'
          value={watch('dataFinal') || ''}
          error={errors?.dataFinal?.message}
          onChange={(item: any) => {
            setValue('dataFinal', item)
            clearErrors('dataFinal')
          }}
        />
        <div className={style.ancpButtonContainer}>
          <Button onClick={onSubmit}>
            <img src={fileDownload} alt='Incluir' />
            Exportar
          </Button>
        </div>
      </div>
    </>
  )
}
